import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { Messages, Formatters } from '../../codegen/Localize';
import { cssClass } from '../../style';
import { DraftMarker } from './DraftMarker';
import { ContentDraftStatus } from '../../ts/ServerApi/types/ContentDraft';
import _ = require('underscore');

export type DraftBannerAction = {
  label: string;
  iconPath: string;
  handleAction: () => void;
}

export type DraftBannerProps = {
  readonly lastEditDate: string;
  readonly contentTypeName: string;
  readonly draftBannerActions: DraftBannerAction[];
};

const DraftBannerWrapperClass = cssClass('DraftBannerWrapperClass', '', {
  display: 'inline-flex',
  height: '44px',
  backgroundColor: '#EEF5F9',
  alignItems: 'center',
  borderRadius: '4px',
});

const MarkerWrapperClass = cssClass('MarkerWrapper', '', {
  paddingLeft: TabStyles.Spacing.LargeSpace
});

const DateWrapperClass = cssClass('DateWrapperClass', '', {
  paddingLeft: TabStyles.Spacing.DefaultSpace,
  fontWeight: 'bold',
});

const ButtonsWrapperClass = cssClass('ButtonsWrapperClass', '', {
  display: 'flex',
  paddingLeft: TabStyles.Spacing.ExtraLargeSpace,
  paddingRight: TabStyles.Spacing.LargeSpace,
});

const ButtonClass = cssClass('ButtonWrapperClass', '', {
  paddingLeft: TabStyles.Spacing.LargeSpace,
});

const ButtonLabelClass = cssClass('ButtonLabelClass', '', {
  marginLeft: TabStyles.Spacing.DefaultSpace,
});

const InlineButtonStyles: React.CSSProperties = {
  padding: `${TabStyles.Spacing.SmallSpace}px ${TabStyles.Spacing.DefaultSpace}px`,
  display: 'inline-flex',
  alignItems: 'center',
};

function renderButtons(draftBannerActions: DraftBannerAction[]): JSX.Element[] {
return _.map(draftBannerActions, (draftBannerAction: DraftBannerAction) => {
  return (
    <div className={ButtonClass} key={`${draftBannerAction.label}-key`}>
      <ButtonWidget
        buttonType={ButtonType.LowEmphasis}
        testId={`draft-banner-${draftBannerAction.label}`}
        handleClick={draftBannerAction.handleAction}
        title={draftBannerAction.label}
        style={InlineButtonStyles}
      >
        <img data-tb-test-id={'draft-banner-action-button-icon'} src={draftBannerAction.iconPath}/>
        <span data-tb-test-id={'draft-banner-action-button-label'} className={ButtonLabelClass}>
          {draftBannerAction.label}
        </span>
      </ButtonWidget>
    </div>
    );
  });
}

export function DraftBanner(props: DraftBannerProps): JSX.Element {
  return (
    <div data-tb-test-id={'draft-banner'} className={DraftBannerWrapperClass} >
      <div className={MarkerWrapperClass}>
        <DraftMarker draftStatus={ContentDraftStatus.unpublishedchanges}/>
      </div>
      <div className={DateWrapperClass}>
        <span data-tb-test-id={'draft-banner-last-edited-message'}>
          {Messages.lastEdited({CONTENT_TYPE: props.contentTypeName, RELATIVE_DATE: Formatters.formatLongBestFitRelativeTime(new Date(props.lastEditDate))})}
        </span>
      </div>
      <div className={ButtonsWrapperClass}>
        {renderButtons(props.draftBannerActions)}
      </div>
    </div>
  );
}
